
import { defineComponent } from "vue";

export class APFormData {
  mac?: string;
  name?: string;
  rssiThreshold?: number;
  stayThreshold?: number;
  congestionBorder1?: number;
  congestionBorder2?: number;

  constructor(attrs = {}) {
    Object.assign(this, attrs);
  }
}

export default defineComponent({
  name: "APForm",
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    form: {
      type: APFormData,
      required: true,
    },
  },
  methods: {
    onChangeForm(v = {}) {
      this.$emit("change", new APFormData({ ...this.form, ...v }));
    },
  },
  components: {},
});
